import instance from '../../Api';

export const checkSchedules = async () => {
  const api = await instance();
  let data = await api
    .get('/partners/check-schedules')
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};
